import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicTableComponent } from '../../components/dynamic-table/dynamic-table.component';
import { TableColumn, RowAction, ActionEvent } from '../../components/dynamic-table/dynamic-table.interface';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-import-review-grid',
  standalone: true,
  imports: [CommonModule, DynamicTableComponent, ButtonModule],
  template: `
    <div class="flex-1 overflow-hidden border border-surface-200 dark:border-surface-700 rounded-xl bg-surface-0 dark:bg-surface-900">
      <app-dynamic-table
        [columns]="columns()"
        [data]="data()"
        [actions]="actions()"
        [loading]="loading()"
        [showToolbar]="false"
        (actionClicked)="onTableAction($event)"
        [paginator]="true"
        [rows]="5"
        [rowsPerPageOptions]="[5, 10, 20]">
      </app-dynamic-table>
    </div>
  `
})
export class ImportReviewGridComponent {
  columns = input.required<TableColumn[]>();
  data = input.required<any[]>();
  loading = input<boolean>(false);
  actions = input<RowAction[]>([]);
  
  action = output<ActionEvent>();
  
  onTableAction(event: any) {
    this.action.emit(event);
  }
}
